import { useCallback, useContext, useEffect, useState } from 'react';
import { Subscription } from 'rxjs';

import { SocketContext } from '../providers/SocketProvider/SocketProvider';
import { Response } from '../services/backendService/types';

const useResponses = (
  gameId: string,
  slideId: string,
  filterDismissed?: boolean,
  tenantId?: string,
) => {
  const [isLoading, setIsLoading] = useState(false);
  const [responses, setResponses] = useState<Response[]>([]);
  const { gameAPI } = useContext(SocketContext);

  useEffect(() => {
    setIsLoading(true);
    let sub: Subscription | undefined;
    if (gameId && gameAPI && tenantId) {
      sub = gameAPI.game
        .onRoundResponsesChanged({ tenantId, gameId, slideId })
        .subscribe(responses => {
          if (filterDismissed) {
            setResponses(responses.filter(r => !r.dismissed));
            setIsLoading(false);
          } else {
            setResponses(responses);
            setIsLoading(false);
          }
        });
    }

    return () => {
      if (sub) {
        sub.unsubscribe();
      }
    };
  }, [gameId, slideId, filterDismissed, gameAPI, tenantId]);

  const localDismiss = useCallback(
    ({ responseId, dismiss }: { responseId: string; dismiss: boolean }) => {
      setResponses(
        responses.map(res =>
          res.id === responseId ? { ...res, dismissed: dismiss } : res,
        ),
      );
    },
    [responses],
  );

  return {
    count: responses.length,
    responses,
    isLoading,
    finishedResponses: responses.filter(r => r.isFinished).length,
    dismissResponse: localDismiss,
  };
};

export default useResponses;
